

























import Vue from 'vue'
import { ProgressBarWithStripesInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'ProgressBarWithStripesEl',
  props: {
    templateItemData: {
      type: Object as () => ProgressBarWithStripesInterface,
      required: true
    }
  },
  computed: {
    leftBarStyle (): string {
      const width = (100 * this.templateItemData.val) / this.templateItemData.maxVal
      return 'background: ' + this.templateItemData.color + '; width: ' + width + '%;'
    },
    rightBarStyle (): string {
      const width = (100 * this.templateItemData.val) / this.templateItemData.maxVal
      return 'width: ' + (100 - width) + '%;'
    },
    stripeStyle (): string {
      const width = (100 * this.templateItemData.stripeVal) / this.templateItemData.maxVal
      return 'width: ' + width + '%;'
    }
  }
})
